import React, { createContext, useContext, useEffect, ReactNode } from 'react';

interface FeatureFlagProviderProps {
  children: ReactNode;
}

interface FeatureFlagContextType {
  initialized: boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContextType>({
  initialized: false,
});

// eslint-disable-next-line react-refresh/only-export-components
export const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error(
      'useFeatureFlagContext must be used within a FeatureFlagProvider'
    );
  }
  return context;
};

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
}) => {
  const [initialized, setInitialized] = React.useState(false);

  useEffect(() => {
    setInitialized(true);
  }, []);

  const contextValue: FeatureFlagContextType = {
    initialized,
  };

  return (
    <FeatureFlagContext.Provider value={contextValue}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
